import { useNavigate } from 'react-router-dom';
// styles
import { AuthWrapper, ErrorIcon, NotifyTitle, PrimaryButton } from '../../styles';

// ----------------------------------------------------------------------

export default function ErrorPage404() {
  const navigate  = useNavigate();

  return (
    <AuthWrapper>
      <ErrorIcon />
      <NotifyTitle>
        <p>500</p>
        <span>서비스를 이용하는 데 문제가 있습니다.<br />
          문제가 지속되면 나중에 다시 시도해 주세요.
        </span>
      </NotifyTitle>

      <PrimaryButton onClick={() => navigate('/', {state: { submit: true }})} style={{'width': '100%'}}>메인으로</PrimaryButton>
    </AuthWrapper>
  );
}